<script setup lang="ts">
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQProps {
  question: string;
  answer: string;
  value: string;
}

const FAQList: FAQProps[] = [
  {
    question: "什么是物联网+AI解决方案？",
    answer: "物联网+AI解决方案是将物联网技术与人工智能技术深度融合，实现设备智能互联、数据智能分析和业务智能优化。我们的解决方案能够帮助企业实现数字化转型，提升运营效率。",
    value: "item-1",
  },
  {
    question: "创诚的产品服务适合哪些行业？",
    answer:
      "我们的产品服务广泛适用于制造业、建筑业、物流仓储、医疗健康、智慧农业、智慧城市等多个领域。只要是需要设备监测、数据分析或智能控制的场景，都可以使用我们的解决方案。",
    value: "item-2",
  },
  {
    question:
      "如何选择适合的服务套餐？",
    answer:
      "建议您根据企业规模和需求选择：小型企业可先体验免费版；中小型企业推荐专业版（性价比高）；大型企业可选择软件定制服务。我们也提供免费咨询服务，帮助您找到最适合的方案。",
    value: "item-3",
  },
  {
    question: "系统部署需要多长时间？",
    answer: "部署时间因项目复杂度而异：免费版和专业版可在1-3个工作日内完成部署；软件定制项目通常需要2-8周不等。我们提供专业的项目管理和现场支持，确保项目按时交付。",
    value: "item-4",
  },
  {
    question:
      "数据安全如何保障？",
    answer: "我们采用企业级安全防护体系：数据传输采用SSL加密；存储数据采用AES256加密；支持本地部署和私有云部署；完善的权限管理和审计日志系统。所有安全措施都符合国家信息安全标准。",
    value: "item-5",
  },
  {
    question: "是否提供技术支持和培训？",
    answer: "是的，我们提供全方位的技术支持：专业版用户享有1年技术支持；软件定制用户享有7x24小时运维支持；免费版用户可获得社区技术支持。此外，我们还提供现场培训、在线培训和操作手册等服务。",
    value: "item-6",
  },
];
</script>

<template>
  <section
    id="faq"
    class="container md:w-[700px] py-24 sm:py-32"
  >
    <div class="text-center mb-8">
      <h2 class="text-lg text-primary text-center mb-2 tracking-wider">物联网+AI常见问题</h2>

      <h2 class="text-3xl md:text-4xl text-center font-bold">
        智能仪表工业自动化
        <span class="text-transparent bg-gradient-to-r from-[#D247BF] to-primary bg-clip-text">
          专业问题解答
        </span>
      </h2>
    </div>

    <Accordion
      type="single"
      collapsible
      class="AccordionRoot"
    >
      <AccordionItem
        v-for="{ question, answer, value } in FAQList"
        :key="value"
        :value="value"
      >
        <AccordionTrigger class="text-left"> {{ question }} </AccordionTrigger>

        <AccordionContent>{{ answer }}</AccordionContent>
      </AccordionItem>
    </Accordion>

    <h3 class="font-medium mt-4">
      还有其他问题？
      <a
        href="#contact"
        class="underline text-primary hover:text-primary/80 transition-colors"
        >联系我们</a
      >
    </h3>
  </section>
</template>
